import { useMemo, useRef } from 'react';
import Fuse from 'fuse.js';
import { shallowEqual, useSelector } from 'react-redux';

const searchOptions = {
  includeScore: true,
  keys: ['label', 'desc'],
};

function defaultSort(a, b) {
  if (a && a.updatedAt && b && b.updatedAt) {
    return new Date(a.updatedAt).getTime() - new Date(b.updatedAt).getTime();
  }
  if (a && a.updatedAt) {
    return 1;
  }
  if (b && b.updatedAt) {
    return -1;
  }
  return 0;
}

function useFilterJoon3Nows({ filters, sortBy }) {
  const queryId = 'default';
  const data = useSelector(
    (store) =>
      (store.joonNows[queryId] && Object.values(store.joonNows[queryId])) || [],
    shallowEqual,
  );
  const lastResult = useRef();
  const jsonFilters = JSON.stringify(filters);
  const filtered = useMemo(() => {
    let _data = data.filter((t) => t);
    if (filters && filters.search) {
      const fuse = new Fuse(_data, searchOptions);
      _data = fuse
        .search(filters.search)
        .sort((a, b) => a.score - b.score)
        .map((i) => i.item);
      lastResult.current = _data;
    } else {
      lastResult.current = _data;
    }
    if (sortBy) {
      return lastResult.current.sort(sortBy);
    }
    return lastResult.current.sort(defaultSort);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jsonFilters, data, sortBy]);
  return filtered;
}

export default useFilterJoon3Nows;
